import { ApolloClient, gql } from '@apollo/client';
import { Dispatch } from 'redux';
import { DecoratedFormProps } from 'redux-form';

import {
  SignUpFormFields,
  SignUpFormProps,
} from 'components/forms/SignUpForm/types';

const asyncValidateSignUpFormQuery = gql`
  query asyncValidate_signUpFormQuery($email: String!) {
    emailExists(email: $email)
  }
`;

interface AsyncValidateSignUpFormQuery {
  emailExists: boolean;
}
interface AsyncValidateSignUpFormQueryVars {
  email: string;
}

export default (client: ApolloClient<unknown>) =>
  async (
    fields: SignUpFormFields,
    dispatch: (dispatch: Dispatch) => void,
    _props: DecoratedFormProps<
      Record<string, unknown>,
      Record<string, unknown>
    >,
  ): Promise<void | { email: string }> => {
    const props = _props as SignUpFormProps;
    const { data } = await client.query<
      AsyncValidateSignUpFormQuery,
      AsyncValidateSignUpFormQueryVars
    >({
      query: asyncValidateSignUpFormQuery,
      variables: {
        email: fields.email,
      },
    });

    if (data.emailExists === true) {
      return { email: props.t('signUpForm.asyncErrors.emailTaken') };
    }
  };
